<div>
  <p-fieldset legend="Avsluta medlemskap {{primarylodgeformember}}">
    <form [formGroup]="terminatemembershipform">
      <div class="form-group">
        <label>Medlem</label>
        <div>{{memberid}} {{givenname}} {{familyname}}</div>
      </div>
      <div class="form-group">
        <label for="fromDate">Från datum</label>
        <app-calendar [form]="terminatemembershipform" formName="fromDate" [required]=true></app-calendar>
      </div>
      <fieldset class="border p-2">
        <legend class="w-auto" style="font-size:14px;">Orsak</legend>
        <br>
        <mat-radio-group formControlName="gott" required>
          <div>
            <mat-radio-button value=8>Medlem lämnat Orden gottstående</mat-radio-button>
          </div>
          <div>
            <mat-radio-button value=11>Medlem lämnat Orden ej gottstående</mat-radio-button>
          </div>
          <div>
            <mat-radio-button value=10>Medlem avliden</mat-radio-button>
          </div>
          <div>
            <mat-radio-button value=9>Medlem lämnat med avgångsbrev</mat-radio-button>
          </div>
        </mat-radio-group>
      </fieldset>
      <br>
    </form>

    <div class="d-flex justify-content-start">
      <button class="btn border" (click)="save()" [disabled]="!terminatemembershipform.valid">Avsluta medlemskapet</button>
      <button class="btn border md-2" (click)="close()">Avbryt</button>  
    </div>

  </p-fieldset>
</div>